import { render, staticRenderFns } from "./StepFinalLetterCreation.vue?vue&type=template&id=3004fbaf&scoped=true&"
import script from "./StepFinalLetterCreation.vue?vue&type=script&lang=js&"
export * from "./StepFinalLetterCreation.vue?vue&type=script&lang=js&"
import style0 from "./StepFinalLetterCreation.vue?vue&type=style&index=0&id=3004fbaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3004fbaf",
  null
  
)

export default component.exports